import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../store/slices/authSlice';

function IdleProvider({ children }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const idleTimeoutRef = useRef(null);

  const clearTimer = () => {
    if (idleTimeoutRef.current) {
      clearTimeout(idleTimeoutRef.current);
      idleTimeoutRef.current = null;
    }
  };

  const handleLogout = () => {
    clearTimer();
    dispatch(logout());
    // Redirect to login page after logout (redux data is already cleared by logout action)
    navigate('/login');
  };

  // Reset idle timer on user activity
  const resetIdleTimer = () => {
    if (!isAuthenticated) {
      clearTimer();
      return;
    }

    // Clear existing timer
    clearTimer();
    
    // Set new timer for 25 minutes of inactivity
    idleTimeoutRef.current = setTimeout(() => {
      // After 25 minutes of inactivity, logout and redirect to login
      handleLogout();
    }, 25 * 60 * 1000); // 25 minutes
  };

  useEffect(() => {
    if (!isAuthenticated) {
      clearTimer();
      return;
    }

    // Listen for user activity events
    const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll', 'click'];
    //events.forEach((event) => window.addEventListener(event, resetIdleTimer));                  /////////no need to reset timer for now since we dont have refresh token/////////
    
    // Start the idle timer
    resetIdleTimer();

    // Cleanup: remove event listeners and clear timer
    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, resetIdleTimer)
      );
      clearTimer();
    };
  }, [isAuthenticated]);

  return <>{children}</>;
}

export default IdleProvider;
